import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const HomeSlider = () => {
  const { t } = useTranslation();
  const images = [
    "/images/slideImage_1.jpeg",
    "/images/slideImage_2.jpeg",
    "/images/slideImage_3.jpeg",
    "/images/slideImage_4.jpeg",
    "/images/slideImage_5.jpeg",
    "/images/slideImage_6.jpeg",
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(timer);
  }, [images.length]);

  return (
    <div style={{ position: "relative", width: "100%", height: "450px" }}>
      {/* ⭐ Constant Text Above Slider */}
      <h1
        style={{
          position: "absolute",
          top: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          color: "#ffffff",
          fontWeight: "600",
          fontFamily: "Poppins",
          fontSize: "22px",
          textShadow: "1px 4px 12px #0d0d0a",
          zIndex: 10,
        }}
      >
        {t("company_name")}
      </h1>

      {/* Slider Image */}
      <img
        src={images[index]}
        alt="slider"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />

      {/* Prev Button */}
      <button
        onClick={() => setIndex((index - 1 + images.length) % images.length)}
        style={{
          position: "absolute",
          top: "50%",
          left: "20px",
          transform: "translateY(-50%)",
          background: "rgba(0,0,0,0.5)",
          color: "#fff",
          border: "none",
          padding: "10px 15px",
          borderRadius: "5px",
          cursor: "pointer",
          zIndex: 10,
        }}
      >
        ❮
      </button>

      {/* Next Button */}
      <button
        onClick={() => setIndex((index + 1) % images.length)}
        style={{
          position: "absolute",
          top: "50%",
          right: "20px",
          transform: "translateY(-50%)",
          background: "rgba(0,0,0,0.5)",
          color: "#fff",
          border: "none",
          padding: "10px 15px",
          borderRadius: "5px",
          cursor: "pointer",
          zIndex: 10,
        }}
      >
        ❯
      </button>
    </div>
  );
};

export default HomeSlider;
